module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8r5r1r-a17b23d67fc855a88e509b7681d28f64.svg";